<!-- Potential changelog component for the dashboard landing -->

<!--
TODO maybe: Make Changelog functional (currently static/demo)


1) Backend 
   - Create an Activity / AuditLog model (user, action, target, timestamp, metadata)
   - Add GET /activity?limit=N endpoint (auth protected)
   - Add POST /activity endpoint
     - User should be inferred from auth token (not sent from frontend)

2) Frontend API
   - Add ActivityService in api.service.js
     - getRecent(limit)
     - create(payload)

3) Vuex
   - Create activity.module.js
   - Add FETCH_ACTIVITY action + SET_ACTIVITY mutation
   - Store recent activity list in Vuex

4) Hook logging into existing actions (fire-and-forget)
   - After successful:
     - PAGE_PUBLISH
     - PAGE_EDIT
     - PAGE_DELETE
     - NAVIGATION_EDIT
   - Dispatch ActivityService.create(...) on success only
   - Do NOT block UX if logging fails

5) Component wiring
   - Replace static items with Vuex getter
   - Fetch activity in created()/mounted()
   - Keep list scrollable and capped (e.g. 10–20 items)

Notes:
- Changelog is informational only (no actions)
- Should never affect core dashboard performance
- Logging failures should be silent
-->

<template>
  <div class="card dashboard-card">
    <div class="card-header d-flex align-items-center justify-content-between">
      <div>
        <h4 class="mb-0">Dashboard Audit Log (demo)</h4>
        <small class="text-muted">Recent dashboard activity</small>
      </div>
    </div>

    <div class="card-body">
      <div v-if="!items.length" class="text-muted">
        No recent changes.
      </div>

      <div v-else class="changelog-list">
        <div v-for="(item, index) in items" :key="index" class="changelog-item">
          <div class="changelog-main">
            <span class="changelog-user">{{ item.user }}</span>
            <span class="changelog-action">{{ item.action }}</span>
            <span class="changelog-target">{{ item.target }}</span>
          </div>

          <div class="changelog-time">
            {{ item.at }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardChangelog",

  data() {
    return {
      // TEMP: static mock data
      items: [
        {
          user: "Hossam",
          action: "updated page",
          target: "Close to Home",
          at: "5 min ago"
        },
        {
          user: "Admin",
          action: "created page",
          target: "Land For Sale",
          at: "32 min ago"
        },
        {
          user: "Alec",
          action: "edited navigation",
          target: "Main Menu",
          at: "1 hr ago"
        },
        {
          user: "Larry",
          action: "deleted page",
          target: "Old Promo Page",
          at: "Yesterday"
        },
        {
          user: "Tex",
          action: "deleted asset",
          target: "crowsuk.jpg",
          at: "2 days ago"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.dashboard-card {
  height: 100%;
}

.changelog-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
}

.changelog-item {
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.changelog-main {
  font-size: 13px;
  line-height: 1.4;
}

.changelog-user {
  font-weight: 600;
  margin-right: 4px;
}

.changelog-action {
  color: #374151;
  margin-right: 4px;
}

.changelog-target {
  font-weight: 500;
  color: #0d6efd;
}

.changelog-time {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
</style>
